import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import Button from 'components/button';

const InvalidModal = ({ isVisible, setVisible, rejectReasons }) => {
  return (
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      // title={'Αδύνατη υποβολή αίτησης'}
      // handleConfirm={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width={400}
      footer={[
        <Button
          label={'Κλείσιμο'}
          type={'default'}
          onClick={() => setVisible(false)}
        />,
      ]}
      className={'invalid-modal'}
    >
      {rejectReasons.case === "checkUniqueness" && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <h2>Αδυναμία Δημιουργίας Αίτησης</h2>
          </div>
          <div className="invalid-modal__body">
            {rejectReasons.responseCode === "901" &&
             <p>Η δημιουργία αίτησης δεν είναι εφικτή καθώς υπάρχει ενεργή αίτηση με το ίδιο ΑΦΜ.</p>
            }
            {!rejectReasons.isActive && <p>Δεν έχετε τη δυνατότητα να υποβάλετε αίτηση, καθώς σύμφωνα με τα στοιχεία της ΑΑΔΕ η Επιχείρησή σας φαίνεται μη ενεργή.</p> }
            {!rejectReasons.isAcceptedRegDate && <p>Δεν έχετε τη δυνατότητα να υποβάλετε αίτηση, καθώς σύμφωνα με τα στοιχεία της ΑΑΔΕ η Ημερομηνία Σύστασης της Επιχείρησής σας είναι μετά τις 30/06/2024.</p>}
          </div>
        </>
      }
      {rejectReasons.case === "submitValidation" && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <h2>Αδυναμία Υποβολής Αίτησης</h2>
          </div>
          <div className="invalid-modal__body">
            <h4>Η αίτησή σας απορρίφθηκε, καθώς:</h4>
            {/* {!rejectReasons.isGreekAfm && <p>δεν είναι Ελληνικό Α.Φ.Μ.</p> } */}
            {/* {!rejectReasons.isActive && <p>δεν είναι ενεργή κατά την ημερομηνία υποβολής της αίτησης Χρηματοδότησης από το Πρόγραμμα.</p> } */}
            {rejectReasons.responseCode === "901" && <p>υπάρχει ήδη ενεργή αίτηση με τον ίδιο τύπο {rejectReasons.equipmentType === 'equipmentTypeThermosifonas' ? 'Αγορά Ηλιακού Θερμοσίφωνα Νέας Τεχνολογίας' : 'Αγορά Συστήματος Αντλιών Θερμότητας Θέρμανσης'}.</p>}
            {rejectReasons.responseCode === "902" && <p>έχετε ήδη λάβει επιδότηση μέσω της δράσης Super-FastBroadband (SFBB).</p>}
            {rejectReasons.responseCode === "903" && <p>το αίτημα δεν είναι αποδεκτό λόγω μη επιλέξιμου ΚΑΔ.</p>}
            {rejectReasons.responseCode === "904" && <p>ο ΑΦΜ έχει υπερβεί το όριο κρατικών ενισχύσεων μέσω του προγράμματος «Smart Readiness»</p>}
            {rejectReasons.responseCode === "905" && <p>έχει παρέλθει η καταληκτική ημερομηνία του προγράμματος, 5 Μαΐου 2025.</p>}
          </div>
        </>
      }
    </Modal>
  );
};

export default InvalidModal;
